import { featuresItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 tracking-wide">
            特色亮点
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            为什么选择51影院？三大核心优势为您解答
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featuresItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8 text-center transition-all duration-200 hover:border-primary-300/50"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-100/80 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${item.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}